import React, { useCallback } from 'react'

import UploadableFile from '../uploadable-file/uploadable-file.component'

import useStyles from './file-display.style'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuth, selectFileUploads, selectUploadProgress, selectCurrentFileUpload } from '@selectors'

import {
  FILE_MODAL_OPEN,
  FILE_REMOVE
} from '@redux/actions/types'

import { startMultipartUploadAction } from '@actions/tips'

const FileDisplay = () => {
  const dispatch = useDispatch()
  const auth = useSelector(selectAuth)
  
  const fileUploads = useSelector(selectFileUploads)
  const progress = useSelector(selectUploadProgress)
  const currentFileUpload = useSelector(selectCurrentFileUpload)

  const classes = useStyles({ fileUploads })

  const handleOnBlob = useCallback(({ fileId, parts, type, mimeType }) => {
    const request = {
      auth,
      data: {
        fileKey: fileId,
        fileType: type,
        mimeType,
        parts
      }
    }

    dispatch(startMultipartUploadAction(request))
  }, [dispatch, auth])

  const handleOnClick = (file) => {
    dispatch({ type: FILE_MODAL_OPEN, payload: { expandedFile: file, cardMediaFiles: fileUploads } })
  }
  
  const handleOnRemove = ({ fileId }) => {
    dispatch({ type: FILE_REMOVE, payload: fileId })
  }

  return (
    <section className={classes.filesContainer}>
      {fileUploads.map(({ fileId, url, type, parts, mimeType }) => <UploadableFile
        key={url}
        file={{ fileId, url, type, parts, mimeType, progress }}
        isUploadingFile={currentFileUpload?.fileId === fileId}
        onBlob={handleOnBlob}
        onClick={handleOnClick}
        onRemove={handleOnRemove}
      />
      )}
    </section>
  )
}

export default FileDisplay
